import { twMerge } from "tailwind-merge"
import { clsx, type ClassValue } from "clsx"

export * from "./api"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function debounce<T extends (...args: any[]) => void>(func: T, wait: number) {
  let timeout: ReturnType<typeof setTimeout> | undefined

  const debounced = ((...args: Parameters<T>) => {
    clearTimeout(timeout)
    timeout = setTimeout(func, wait, ...args)
  }) as T & { cancel: () => void }

  debounced.cancel = () => clearTimeout(timeout)

  return debounced
}
